module.exports = __webpack_public_path__ + "static/media/img1.dae52ae5.jpg";